<div [id]="id" class="dropdown search-dropdown">
  <div class="label-top-left" *ngIf="selectedItem">{{label | translate}}</div>
  <button
    #dropdownButton
    class="btn button-common"
    [ngClass]="{'button-regular': !alternateLook, 'button-alternate': alternateLook}"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    [disabled]="items.length === 0"
    [ngStyle]="{'border-radius': borderRadius}"
  >
    <span class="value-text" *ngIf="!selectedItem">{{label | translate}}</span>
    <span class="value-text" *ngIf="selectedItem">{{selectedItem.name}}</span>
    <div class="arrow-box">
      <i *ngIf="!alternateLook" class="arrow-custom --xsmall down"></i>
      <img *ngIf="alternateLook" src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down"/>
    </div>
  </button>

  <ul class="dropdown-menu">
    <div class="search-input">
      <img src="../../assets/icons/search.svg" alt="Search icon"/>
      <input
        type="text"
        placeholder="{{ 'COMMON.SEARCH' | translate }}"
        [(ngModel)]="searchValue"
        (input)="applySearchFilter()"
      />
    </div>

    <div class="dropdown-items">
      <div
        [id]="id + '_item-' + (i + 1)"
        *ngFor="let item of filteredItems; let i = index"
         [ngClass]="{'dropdown-item': true, 'selected': selectedItem && item.id === selectedItem.id}"
        (click)="selectItem(item)"
        click-stop-propagation
      >
        <span>{{item.name}}</span>
      </div>
    </div>
  </ul>
</div>